import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { Card, Statistic } from 'antd';
import React from 'react';

interface StatCardProps {
  title: string;
  value: number;
  trend?: number | null;
}

const StatCard: React.FC<StatCardProps> = ({ title, value, trend }) => {
  const trendSuffix =
    trend != null ? (
      <span style={{ fontSize: 14, marginLeft: 8 }}>
        {trend >= 0 ? (
          <ArrowUpOutlined style={{ color: '#3f8600' }} />
        ) : (
          <ArrowDownOutlined style={{ color: '#cf1322' }} />
        )}
        <span style={{ color: trend >= 0 ? '#3f8600' : '#cf1322', marginLeft: 4 }}>
          {Math.abs(trend)}%
        </span>
      </span>
    ) : null;

  return (
    <Card>
      <Statistic title={title} value={value} suffix={trendSuffix} />
    </Card>
  );
};

export default StatCard;
